require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-multilateral-development-banks-mdbs-have-the-potential.json") })
        }
      }, "path---en-us-update-multilateral-development-banks-mdbs-have-the-potential");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-multilateral-development-banks-mdbs-have-the-potential!./.cache/json/en-us-update-multilateral-development-banks-mdbs-have-the-potential.json
// module id = 777
// module chunks = 231608221292675